import { useI18Next } from "@agrigate/shared/lib/utils/i18n";
import { Provider } from "@agrigate/shared-web-ui/lib/components/ui/provider";
import { Toaster } from "@agrigate/shared-web-ui/lib/components/ui/toaster";
import { useHashRouteRedirect } from "@agrigate/shared-web-ui/lib/hooks/use-hash-route-redirect";
import ReactRouterAdapter from "@agrigate/shared-web-ui/lib/utils/qparams-react-router-adapter";
import { type ReactElement, Suspense, useEffect } from "react";
import { useRoutes } from "react-router";
import { QueryParamProvider } from "use-query-params";
import routes from "~react-pages";
import LoginGuard from "./components/LoginGuard";

export default function App(): ReactElement | null {
    const {
        isInitialized,
        initialize: initI18N,
        changeLanguage,
    } = useI18Next(API_BASE);

    useEffect(() => {
        initI18N();
        const localeCode = localStorage.getItem("ag:locale-code");
        if (localeCode) changeLanguage(localeCode);
    }, []);

    const routeView = useRoutes(routes);

    useHashRouteRedirect();

    if (!isInitialized) return null;

    return (
        <Provider>
            <QueryParamProvider adapter={ReactRouterAdapter}>
                <Suspense
                    fallback={
                        <div style={{ minHeight: "100vh" }}>
                            <p>Loading...</p>
                        </div>
                    }
                >
                    <LoginGuard>{routeView}</LoginGuard>
                </Suspense>
            </QueryParamProvider>
            <Toaster />
        </Provider>
    );
}
